import React from "react";
import { Box } from "@mui/material";
import BillingHeader from "./BillingHeader";
import BillingFooter from "./BillingFooter";
import BillingPatientDetails from "./BillingPatientDetails";
import BillingContent from "./BillingContent";

const BillingPDFExport = ({
  billingData,
  selectedSections,
}: {
  billingData: any;
  selectedSections: { [key: string]: boolean };
}) => {
  return (
    <div
      className="print-container"
      style={{
        flexGrow: 1,
        width: "100%",
      }}>
      <table
        style={{
          pageBreakInside: "avoid",
          width: "100%",
        }}>
        <thead>
          <tr>
            <td>
              {selectedSections?.HEADER &&
                billingData?.informationColl?.[0]?.headerEnable && (
                  <Box className="header">
                    <BillingHeader
                      headerData={billingData?.informationColl?.[0]}
                    />
                  </Box>
                )}
              <Box>
                <BillingPatientDetails
                  patientData={billingData?.billingHeadColl?.[0]}
                  informationData={billingData?.informationColl?.[0]}
                />
              </Box>
            </td>
          </tr>
        </thead>
        <tbody
          style={{
            height: "100%",
            verticalAlign: "top",
          }}>
          <tr style={{ height: "100%" }}>
            <td>
              <Box className="content">
                <BillingContent
                  billingContent={billingData?.billingDetailColl}
                  billingContentData={billingData?.billingHeadColl?.[0]}
                  paymentContent={billingData?.paymentColl}
                  selectedSections={selectedSections}
                />
              </Box>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <Box className="footer">
                <BillingFooter
                  footerData={billingData?.billingHeadColl?.[0]}
                  informationData={billingData?.informationColl?.[0]}
                  selectedSections={selectedSections}
                />
              </Box>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default BillingPDFExport;
